module.exports = __webpack_public_path__ + "static/media/training-at-home.4b281777.png";